// extracted by mini-css-extract-plugin
export var benefits = "benefits-module--benefits--rFyW3";
export var header = "benefits-module--header--1QCfX";
export var content = "benefits-module--content--1trLR";
export var benefit = "benefits-module--benefit--2JNW4";